import {gql} from 'apollo-angular';

export const GET_GAME_JS_SCHOOL_CLASS_ENTRY = gql`
  query GetGameJrSchoolClass($schoolClassId: Int!) {
    getGameJRSchoolClassEntry(gameJRSchoolClassID: $schoolClassId) {
      id
      job {
        id
        name
      }
      avatarImage {
        medium {
          url
          width
        }
      }
      jobImage {
        medium {
          url
          width
        }
      }
      requirementType {
        jobRequirementType {
          id
          typeName
        }
        requirements {
          id
          bicID
          requirementName
          description
        }
      }
    }
  }
`;
